import { AuthService } from 'src/app/Service/AuthService';
import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import { BasePopoverContentsComponent } from 'src/app/View/BaseUI/BasePopoverContentsComponent';


/**
 * HealthInsurePopupComponent
 * 保険証アップロードダイアログ

	 // 呼び出し方：
		// BaseViewの表示メソッドを呼ぶ。
		// 第1引数： 中身のコンポーネントクラス
		// 第2引数： 中身に渡すデータ。
		this.showDialogWindow(
			PopoverChangeCounselComponent,
			{
				title: '警告',
				text: '削除してもよろしいですか？',
				close: this.confirmReceive.bind(this)
			 }
		);

	// 中身に渡すデータ構造：
	{
		title: '確認',							// タイトル用 文字列	HTML側にバインディングで使用
		text: '登録してよろしいですか？',		// 本文					HTML側にバインディングで使用
		close: this.confirmReceive.bind(this)	// 終了メソッドが入る。現在は、これで結果受け取る構造。
	 }

	close用メソッドは、下記の引数で用意する。
	confirmReceive(ret: boolean)

*/
@Component({
	selector: 'popover-confirm-component',
	templateUrl: './HealthInsurePopupComponent.html',
	styleUrls: ['./HealthInsurePopupComponent.scss'],
})
export class HealthInsurePopupComponent extends BasePopoverContentsComponent {

	// 保険証の表写真データ
	@ViewChild('fileFront') fileFront: ElementRef;
	// 保険証の裏写真データ
	@ViewChild('fileBack') fileBack: ElementRef;

	// 送信するデータオブジェクト
	public formData: any = {};

	/**
	 * constructor
	 *
	 */
	constructor(
			public dialogCtrl: MatDialog,
			public dialogRef: MatDialogRef<HealthInsurePopupComponent>, //自分の参照。これにcloseしてもいい
			@Inject(MAT_DIALOG_DATA) public data: any, // 呼び出し側から受け取るデータ
	) {
		// Angularのコンポーネントなので上位を呼ぶ。
		super();
	}

	/**
	 * start
	 * 開始処理
	 */
	public start() {

	}




	/**
	 * sendHealthInsureImage
	 * サーバーに保険証の写真を送信する
	 */
	public async onClickSendHealthInsureImage() {



		const data = {
			front: null,
			back: null
		};

		if (this.fileFront.nativeElement.files.length > 0) {
			this.log(this.fileFront.nativeElement.files[0]);
			data.front = this.fileFront.nativeElement.files[0];
		}
		if (this.fileBack.nativeElement.files.length > 0) {
			this.log(this.fileBack.nativeElement.files[0]);
			data.back = this.fileBack.nativeElement.files[0];
		}

		if (data.front === null || data.back === null) {
			this.showAlertDialog('エラー', '表面と裏面が必要です');
			return;
		}
		// 表裏の写真をサーバーに送信する
		await this.data.success(data);

	}

	/**
	 * onClickCansel
	 * キャンセルクリック
	 */
	public onClickCansel(){
		this.data.close();
	}


}
